import React from 'react';

import type { VisitorCustomFieldConfig } from 'graphql-query-contracts';

import styles from './CustomFieldRenderer.scss';

type CustomFieldRendererProps = {
  field: VisitorCustomFieldConfig;
};

export function CustomFieldRenderer({ field }: CustomFieldRendererProps) {
  const renderInput = () => {
    switch (field.fieldType) {
      case 'textarea':
        return (
          <textarea
            className={styles.fieldTextarea}
            disabled
            placeholder={field.placeholder ?? ''}
            data-test={`customField-textarea-${field.fieldKey}`}
          />
        );

      case 'select_dd':
        return (
          <select
            className={styles.fieldSelect}
            disabled
            data-test={`customField-select-${field.fieldKey}`}
          >
            <option value="">{field.placeholder ?? ''}</option>
            {field.options?.map(option => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        );

      case 'select_radio':
        return (
          <div
            className={styles.radioGroup}
            data-test={`customField-radio-${field.fieldKey}`}
          >
            {field.options?.map(option => (
              <label key={option} className={styles.optionLabel}>
                <input type="radio" disabled name={field.fieldKey} />
                <span>{option}</span>
              </label>
            ))}
          </div>
        );

      case 'multi_select':
        return (
          <div
            className={styles.checkboxGroup}
            data-test={`customField-checkbox-${field.fieldKey}`}
          >
            {field.options?.map(option => (
              <label key={option} className={styles.optionLabel}>
                <input type="checkbox" disabled />
                <span>{option}</span>
              </label>
            ))}
          </div>
        );

      default:
        return (
          <input
            type="text"
            className={styles.fieldInput}
            disabled
            placeholder={field.placeholder ?? ''}
            data-test={`customField-text-${field.fieldKey}`}
          />
        );
    }
  };

  return (
    <div className={styles.fieldWrapper} data-test={`customFieldRenderer-${field.fieldKey}`}>
      <label className={styles.fieldLabel}>
        {field.fieldName}
      </label>
      {renderInput()}
    </div>
  );
}
